import { Button, ButtonProps, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { RiAddCircleLine } from "react-icons/ri";
import * as AF from "src/types/formTemplate";
import * as RD from "src/types/remoteData";
import { QuestionFormNewDrawer } from "./QuestionForm/New";
import { SchoolItem } from "./QuestionForm/types";

type AddQuestionButtonProps = {
  children: React.ReactNode;
  questionIndex: number;
  section: AF.V3.Section;
  schools: RD.RemoteData<unknown, SchoolItem[]>;
  otherQuestions: AF.V3.Question[];
  buttonProps?: ButtonProps;
};
export const AddQuestionButton: React.FC<AddQuestionButtonProps> = ({
  children,
  section,
  schools,
  questionIndex,
  otherQuestions,
  buttonProps,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <QuestionFormNewDrawer
        questionIndex={questionIndex}
        onClose={onClose}
        section={section}
        otherQuestions={otherQuestions}
        isOpen={isOpen}
        schools={schools}
      />
      <Button
        variant="ghost"
        colorScheme="gray"
        leftIcon={<RiAddCircleLine />}
        size="sm"
        alignSelf="flex-end"
        onClick={onOpen}
        {...buttonProps}
      >
        {children}
      </Button>
    </>
  );
};
